export const META_TITLE = 'CertiHire Admin panel';

export const TOOLTIP_BACKGROUND_COLOR = '#535353'